export default __webpack_public_path__ + "static/media/founder1.6a7a7b35.jpeg";